import styled, { FlattenSimpleInterpolation, css } from 'styled-components';

export type TAlignment = 'top' | 'center' | 'bottom' | 'left' | 'right';

const ALIGN_STYLES: Record<TAlignment, FlattenSimpleInterpolation> = {
  top: css`
    align-items: flex-start;
    justify-content: center;
  `,
  center: css`
    align-items: center;
    justify-content: center;
  `,
  bottom: css`
    align-items: flex-end;
    justify-content: center;
  `,
  left: css`
    align-items: center;
    justify-content: flex-start;
  `,
  right: css`
    align-items: center;
    justify-content: flex-end;
  `,
};

interface IVisibleProps {
  visible: boolean;
  align: TAlignment;
  elevated: boolean;
}

/**
 * Todos os modais sao portados para o body com o mesmo z-index, entao quem fica
 * na frente e decidido pela ordem de montagem. Um modal aberto a partir de outro
 * precisa de `elevated` para nao ficar atras de quem o abriu.
 */
const BASE_Z_INDEX = 7000;
const ELEVATED_Z_INDEX = 7500;

export const Overlay = styled.div<IVisibleProps>`
  ${({ visible, align, elevated }) => css`
    position: fixed;
    inset: 0;
    height: 100vh;
    height: 100dvh;
    background-color: rgba(0, 0, 0, 0.25);
    transition: 0.3s;
    opacity: 0;
    z-index: -1;
    visibility: hidden;

    ${visible &&
    css`
      opacity: 1;
      z-index: ${elevated ? ELEVATED_Z_INDEX : BASE_Z_INDEX};
      visibility: visible;
    `};

    display: flex;
    ${ALIGN_STYLES[align]}

    .modal-dialog {
      display: flex;
      align-items: center;
      flex-direction: center;
    }
  `}
`;
